function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#8AD18D"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_95632_6642)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.665 11.9346L20.791 10.3281H19.2871L20.7812 12.9111L19.2188 15.6113H20.7227L21.6748 13.9121L22.627 15.6113H24.1309L22.5684 12.9111L24.0625 10.3281H22.5635L21.665 11.9346ZM21.1968 17.4119C21.5159 17.0928 21.8578 17.0928 22.2224 17.4119L24.4789 19.5999C24.7751 19.9418 24.7751 20.2837 24.4789 20.6256L22.2908 22.8136C22.1313 22.9503 21.9603 23.0187 21.778 23.0187C21.5729 23.0187 21.4019 22.9503 21.2652 22.8136C20.9233 22.4717 20.9233 22.1298 21.2652 21.7879L22.2224 20.8307H19.3506C18.3706 20.8307 17.476 20.5743 16.6669 20.0615C15.8578 19.5486 15.2253 18.8592 14.7694 17.9931L14.3934 17.3435L13.6071 15.7367L12.7865 14.1298C12.0572 12.7623 10.9632 12.0785 9.50449 12.0785H7.82928C7.64694 12.0785 7.4817 12.0045 7.33355 11.8563C7.1854 11.7082 7.11133 11.5429 7.11133 11.3606C7.11133 11.1783 7.1854 11.013 7.33355 10.8649C7.4817 10.7167 7.64694 10.6427 7.82928 10.6427H9.50449C10.4845 10.6427 11.3848 10.8991 12.2053 11.4119C13.0259 11.9247 13.6412 12.6142 14.0515 13.4803L14.3934 14.1298L15.2139 15.7367L16.0002 17.3435C16.3193 17.9589 16.7751 18.4546 17.3677 18.8307C17.9603 19.2068 18.5985 19.3948 19.2823 19.3948H22.1199L21.1968 18.4375C20.8549 18.0956 20.8549 17.7538 21.1968 17.4119Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_95632_6642"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.7778,
  height: 17.7778,
  fill: "white",
  transform: "translate(7.11133 7.61133)"
})));

function SvgStrategyLeastUsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyLeastUsed);
export default __webpack_public_path__ + "static/media/strategyLeastUsed.539f56d1.svg";
export { ForwardRef as ReactComponent };